export default [
    {
        path: '/questionnarie', // 问卷调查首页
        component: resolve => require(['@/pages/activity/survey/questionnaire'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/questionnaireSrvey', // 问卷调查题目
        component: resolve => require(['@/pages/activity/survey/questionnaireSrvey'], resolve),
        meta: { title: "长龙航空" }
    },
]


// WEBPACK FOOTER //
// ./src/router/modules/question.js